import { EmployeeLevelEnum } from '../../../../types'

export const PARTNER_LEVELS: EmployeeLevelEnum[] = [
  EmployeeLevelEnum.P,
  EmployeeLevelEnum.Ap,
  EmployeeLevelEnum.Ep,
  EmployeeLevelEnum.Sp,
  EmployeeLevelEnum.D,
  EmployeeLevelEnum.Pro,
  EmployeeLevelEnum.Co,
]

export const isEmployeePartner = (employeeLevel: EmployeeLevelEnum): boolean => {
  return PARTNER_LEVELS.includes(employeeLevel)
}
